import { Translatable } from '@app/types/translatable.type';

const BasicInformationFieldNamesOptions: { [key: string]: Translatable } = {
    firstName: 'forms.field-groups.firstName',
    lastName: 'forms.field-groups.lastName',
    phone: 'forms.field-groups.phone',
    gender: 'forms.field-groups.gender',
    pronouns: 'forms.field-groups.pronouns',
};

const PersonalInformationFieldNamesOptions: { [key: string]: Translatable } = {
    legalFirstName: 'forms.field-groups.legalFirstName',
    legalMiddleName: 'forms.field-groups.legalMiddleName',
    legalLastName: 'forms.field-groups.legalLastName',
    legalSex: 'forms.field-groups.legalSex',
    mobilePhone: 'forms.field-groups.mobilePhone',
    homePhone: 'forms.field-groups.homePhone',
    dietaryRestrictions: 'forms.field-groups.dietaryRestrictions',
    dateOfBirth: 'forms.field-groups.dateOfBirth',
    sin: 'forms.field-groups.sin',
};

const AddressFieldNamesOptions: { [key: string]: Translatable } = {
    streetAddress: 'forms.field-groups.streetAddress',
    unitOrSuite: 'forms.field-groups.unitOrSuite',
    city: 'forms.field-groups.city',
    postalCod: 'forms.field-groups.postalCod',
    provinceOrState: 'forms.field-groups.provinceOrState',
    country: 'forms.field-groups.country',
};

const EmergencyContactsFieldNamesOptions: { [key: string]: Translatable } = {
    primaryName: 'forms.field-groups.primaryName',
    primaryRelation: 'forms.field-groups.primaryRelation',
    primaryPhone: 'forms.field-groups.primaryPhone',
    secondaryName: 'forms.field-groups.secondaryName',
    secondaryRelation: 'forms.field-groups.secondaryRelation',
    secondaryPhone: 'forms.field-groups.secondaryPhone',
};

const EmploymentInformationFieldNamesOptions: { [key: string]: Translatable } = {
    dateHired: 'forms.field-groups.dateHired',
    reportsTo: 'forms.field-groups.reportsTo',
    department: 'forms.field-groups.department',
    position: 'forms.field-groups.position',
    officeLocation: 'forms.field-groups.officeLocation',
    employmentType: 'forms.field-groups.employmentType',
    stockOption: 'forms.field-groups.stockOption',
    additional: 'forms.field-groups.additional',
};

const BankAccountFieldNamesOptions: { [key: string]: Translatable } = {
    paymentMethod: 'forms.field-groups.paymentMethod',
    bankInstitution: 'forms.field-groups.bankInstitution',
    bankBranch: 'forms.field-groups.bankBranch',
    bankAccount: 'forms.field-groups.bankAccount',
};

export {
    AddressFieldNamesOptions,
    BankAccountFieldNamesOptions,
    BasicInformationFieldNamesOptions,
    EmergencyContactsFieldNamesOptions,
    EmploymentInformationFieldNamesOptions,
    PersonalInformationFieldNamesOptions,
};
